export const isBoolean = (value: string): boolean => {
  if (value.length >= 3 && value.substring(0, 3) === "B::") {
    return true;
  }
  return false;
};

export const parseBoolean = (value: string): boolean => {
  return value.substring(3).toUpperCase() === "TRUE";
};

export const isNumber = (value: string): boolean => {
  if (value.length >= 3 && value.substring(0, 3) === "N::") {
    return true;
  }
  return false;
};

export const parseNumber = (value: string): number => {
  return Number(value.substring(3));
};

export const tryParseFilterValueString = (
  filterValue: string
): string | number | boolean => {
  if (isBoolean(filterValue)) {
    return parseBoolean(filterValue);
  } else if (isNumber(filterValue)) {
    return parseNumber(filterValue);
  } else {
    return filterValue;
  }
};
